/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitation_Co_OrganizeInputs */

const th_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ได้รับเชิญให้ร่วมจัดการแข่งขัน`)
};

const en_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invited to co-organise`)
};

const ja_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共同主催者として招待されています`)
};

const zh_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受邀成为联合主办方`)
};

const es_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitado a coorganizar`)
};

const pt_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convidado para coorganizar`)
};

const id_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diundang sebagai penyelenggara pendamping`)
};

const fr_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invité à coorganiser`)
};

const tl_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inanyayahang maging co-organizer`)
};

const vi_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Được mời đồng tổ chức`)
};

const ko_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공동 주최자로 초대됨`)
};

const de_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Mitveranstalter eingeladen`)
};

const ru_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашение стать соорганизатором`)
};

const tr_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yardımcı düzenleyici olarak davet edildi`)
};

const it_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitato come co-organizzatore`)
};

const pl_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaproszenie do współorganizacji`)
};

const uk_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запрошення стати співорганізатором`)
};

const hi_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सह-आयोजक के रूप में आमंत्रित`)
};

const ar_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوة للمشاركة في التنظيم`)
};

const ms_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dijemput sebagai penganjur bersama`)
};

const bn_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সহ-আয়োজক হিসেবে আমন্ত্রিত`)
};

const zh_tw2_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受邀擔任共同主辦`)
};

const zh_hk2_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受邀擔任共同主辦`)
};

const ur_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شریک منتظم کے طور پر مدعو`)
};

const fa_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوت به هم‌برگزاری`)
};

const sw_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umealikwa kuwa mwandalizi mwenza`)
};

const nl_invitation_co_organize = /** @type {(inputs: Invitation_Co_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgenodigd als mede-organisator`)
};

/**
* | output |
* | --- |
* | "Invited to co-organise" |
*
* @param {Invitation_Co_OrganizeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invitation_co_organize = /** @type {((inputs?: Invitation_Co_OrganizeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitation_Co_OrganizeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invitation_co_organize(inputs)
	if (locale === "ja") return ja_invitation_co_organize(inputs)
	if (locale === "zh") return zh_invitation_co_organize(inputs)
	if (locale === "es") return es_invitation_co_organize(inputs)
	if (locale === "pt") return pt_invitation_co_organize(inputs)
	if (locale === "id") return id_invitation_co_organize(inputs)
	if (locale === "fr") return fr_invitation_co_organize(inputs)
	if (locale === "tl") return tl_invitation_co_organize(inputs)
	if (locale === "vi") return vi_invitation_co_organize(inputs)
	if (locale === "ko") return ko_invitation_co_organize(inputs)
	if (locale === "de") return de_invitation_co_organize(inputs)
	if (locale === "ru") return ru_invitation_co_organize(inputs)
	if (locale === "tr") return tr_invitation_co_organize(inputs)
	if (locale === "it") return it_invitation_co_organize(inputs)
	if (locale === "pl") return pl_invitation_co_organize(inputs)
	if (locale === "uk") return uk_invitation_co_organize(inputs)
	if (locale === "hi") return hi_invitation_co_organize(inputs)
	if (locale === "ar") return ar_invitation_co_organize(inputs)
	if (locale === "ms") return ms_invitation_co_organize(inputs)
	if (locale === "bn") return bn_invitation_co_organize(inputs)
	if (locale === "zh-TW") return zh_tw2_invitation_co_organize(inputs)
	if (locale === "zh-HK") return zh_hk2_invitation_co_organize(inputs)
	if (locale === "ur") return ur_invitation_co_organize(inputs)
	if (locale === "fa") return fa_invitation_co_organize(inputs)
	if (locale === "sw") return sw_invitation_co_organize(inputs)
	if (locale === "nl") return nl_invitation_co_organize(inputs)
	return en_invitation_co_organize(inputs)
});